module.exports = __webpack_public_path__ + "static/media/richmond-logo.fc6e03e9.svg";